<!-- 財務 -> 应付管理 -> 供应商付款 -->
<template>
    <div class="templete">
        <div class="search_box clearfix">
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.supplier_id"
                collapse-tags filterable placeholder="供应商名称:" @visible-change="getSelectList('supplier')">
                <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id"
                    :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.currency_id"
                multiple collapse-tags placeholder="币种:" @visible-change="getSelectList('currency')">
                <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                    :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.salesman_id" multiple collapse-tags filterable placeholder="归属人:" @visible-change="getSalesman">
                <el-option v-for="list in salesmanList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="reset fcolor" @click="resetSearch">重置</div>
            <el-button class="publicBtn" @click="getList(true)">查询</el-button>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batch">付款/退款</el-button>
            <el-button class="funcPublicBtn" @click="payOtherDeposit">添加其他应付</el-button>
            <el-button class="funcPublicBtn" @click="settlementOpen">结算其他应付</el-button>
            <!-- <el-button class="funcPublicBtn" @click="addFirst">添加期初</el-button> -->
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @sortTable="sortTable"
                @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">采购余额:{{totalObj.balance}}</div>
            <div class="totalNumber">未结金额:{{totalObj.unbalance}}</div>
            <div class="totalNumber">其他应付:{{totalObj.other_amount}}</div>
            <div class="totalNumber">优惠/赔偿金:{{totalObj.paid_amount}}</div>
            <div class="totalNumber">
                <div class="contractLabel" style="position:relative;">
                    <div class="labelTip" style="width:330px;">
                        <div class="laCbelTipC">
                            未结金额+其他应付-采购余额-优惠/赔偿金
                        </div>
                    </div>
                    <span> 应付总额:{{totalObj.payment_amount}}</span>
                </div>
            </div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total"
                :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 新增收款单 dialog START -->
        <el-dialog v-dialog-drag title="付款/退款单" :visible.sync="addDialogVisible" class="eldialog eldialogLine auto"
            :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" :rules="addRules" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：" prop="trading_time">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：" prop="account_id">
                        <el-select v-model="add_params.account_id" placeholder=""
                            @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="add_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：" prop="bill_type">
                        <el-select v-model="add_params.bill_type" placeholder="" filterable @change="billChange()"
                            @visible-change="getSelectList('purchaseBillType')">
                            <el-option v-for="item in selectMap.purchaseBillType" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="付款方式：" prop="payment_type_id">
                        <el-select v-model="add_params.payment_type_id" placeholder=""
                            @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input disabled v-if="add_params.bill_type==0" placeholder="采购退款"></el-input>
                        <el-input disabled v-if="add_params.bill_type==1" placeholder="支出"></el-input>
                        <el-input disabled v-if="add_params.bill_type==5" placeholder="优惠/赔偿退款"></el-input>
                    </el-form-item>
                    <el-form-item :label="add_params.bill_type==1?'付款金额：':'收款金额：'" class="dialogTwo clearfix"
                        prop="currency_id">
                        <el-select class="twoSelect" v-model="add_params.currency_id" @change="billChange()"
                            @visible-change="getSelectList('currency')" :disabled="currencyDis">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                            <!-- +'+'+list.name -->
                        </el-select>
                        <el-input class="twoInput" @input.native="changeRate($event,add_params.amount)"
                            @input="AmountCalculation($event,add_params.currency_rate)"
                            v-model="add_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item :label="add_params.bill_type==1?'付款汇率：':'收款汇率：'" prop="currency_rate">
                        <el-input v-model="add_params.currency_rate" :disabled="isRenminbi"
                            @input="AmountCalculation(add_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥金额：">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="pay_file" style="height: auto;">
                        <span slot="label"><span>凭证：</span>
                        </span>
                        <ym-upload ref="payUp" :limit="5" :init-list="fileListShow" :disabled="false"
                            :form-param.sync="add_params.files"></ym-upload>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
        <!--添加期初START-->
        <el-dialog v-dialog-drag :visible.sync="initDialogVisible" class="eldialog eldialogLine deepStyle auto"
            width="285px" :modal="false" title="添加期初" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB" style="text-align: left">
                    <el-form-item label="供应商：">
                        <el-select v-model="initForm.id" @visible-change="getSelectList('supplier')" filterable>
                            <el-option v-for="(list,index) in selectMap.supplier" :key="index" :value="list.id"
                                :label="list.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="期初金额：">
                        <el-input v-model="initForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input type="textarea" :rows="3" v-model="initForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol" style="padding-top: 50px">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveInit">添加保存</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加期初END-->
        <!-- 其他应付单 dialog START -->
        <el-dialog v-dialog-drag title="添加其他应付" :visible.sync="addOtherDepositDialog"
            class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="otherDeposit_params" :rules="otherDepositRules" ref="add_form"
                class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="添加时间：" prop="trading_time">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="otherDeposit_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="应付金额：" class="dialogTwo clearfix" prop="currency_id">
                        <el-select class="twoSelect" v-model="otherDeposit_params.currency_id"
                            @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.unit"></el-option>
                        </el-select>
                        <el-input class="twoInput" @input.native="changeRate($event,otherDeposit_params.amount)"
                            @input="AmountCalculation($event,otherDeposit_params.currency_rate)"
                            v-model="otherDeposit_params.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="otherDeposit_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addOtherDepositDialog=!addOtherDepositDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addotherDepositBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 其他应付单 dialog END -->
        <!-- 结算确认单 dialog START -->
        <el-dialog v-dialog-drag title="结算其他应付" :visible.sync="addSettlementDialog"
            class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="settlement_params" ref="add_form" :rules="addSettlementDialogRules"
                class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="结算日期：">
                        <el-date-picker v-model="trading_time" type="date"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="供应商名称：" prop="supplier_id">
                        <el-select v-model="settlement_params.supplier_id" placeholder="" filterable disabled
                            @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id"
                                :value="item.id" :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="结算方式：">
                        <el-select v-model="settlement_params.bill_type" placeholder="" @change="currencyChange"
                            @visible-change="getSelectList('settlementType')">
                            <el-option v-for="item in selectMap.settlementType" :key="item.id" :value="item.id"
                                :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="币种：">
                        <el-select class="twoSelect" v-model="settlement_params.currency_id" disabled
                            @visible-change="getSelectList('currency')">
                            <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id"
                                :label="list.name+'（'+list.unit+'）'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购余额：" class="other_form_item" v-if="settlement_params.bill_type==1">
                        <div style="text-align:left;">{{purchaseBalance}}</div>
                    </el-form-item>
                    <el-form-item label="优惠赔偿金：" class="other_form_item" v-if="settlement_params.bill_type==2">
                        <div style="text-align:left;">{{purchaseBalance}}</div>
                    </el-form-item>
                    <el-form-item label="其他应付：" class="other_form_item">
                        <div style="text-align:left;">{{amountPayable}}</div>
                    </el-form-item>
                    <el-form-item label="结算金额：">
                        <el-input v-model="settlement_params.amount"
                            @input.native="changeRate($event,settlement_params.amount)"
                            @input="AmountCalculation($event,settlement_params.currency_rate)"
                            placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label=" 汇率：" v-if="settlement_params.bill_type==2" prop="currency_rate">
                        <el-input v-model="settlement_params.currency_rate" :disabled="isRenminbi"
                            @input="AmountCalculation(settlement_params.amount,$event)" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="¥金额：" v-if="settlement_params.bill_type==2">
                        <el-input v-model="paymentAmount" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="settlement_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn"
                    @click="addSettlementDialog=!addSettlementDialog">取消</el-button>
                <el-button class="publicBtn dialogBtn" @click="addsettlementBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 结算确认单 dialog END -->
        <!-- 其他应付详情 START -->
        <el-dialog v-dialog-drag :visible.sync="otherDetailFlag" class="eldialog specTable" width="820px" :modal="false"
            title="其他应付添加记录" custom-class="full_dialog">
            <el-table :data="otherDetail" border stripe highlight-current-row size="mini" height="100%"
                style="max-height:400px">
                <el-table-column key="1" type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column key="2" label="操作" width="50">
                    <template slot-scope="scope">
                        <div class="icon_wrap">
                            <i class="operation_delete" @click="otherDetailDelete(scope.$index,scope.row.id)"
                                title="删除"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="添加日期" prop="trading_time" show-overflow-tooltip></el-table-column>
                <el-table-column label="添加人" prop="operator_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="供应商名称" prop="customer_name" show-overflow-tooltip></el-table-column>
                <el-table-column label="金额" prop="amount" show-overflow-tooltip></el-table-column>
                <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
            </el-table>
        </el-dialog>
        <!-- 其他应付详情 END -->
    </div>
</template>
<style lang="scss" scoped>
    .deepStyle /deep/ .el-textarea__inner {
        padding: 5px;
        border-color: #a7a7a7;
        font-size: 12px;
    }

    .deepStyle /deep/ .el-form-item {
        margin-left: 0;
        width: 258px;
    }

    .deepStyle /deep/ .el-form-item .el-form-item__content {
        width: 160px;
    }

    .path_title_name {
        float: left;
    }

    .redQuestion {
        display: block;
        width: 15px;
        height: 15px;
        background: url('/icon/question.png') no-repeat 100%;
        background-size: 100% 100%;
    }

    .labelZhu {
        font-size: 12px;
        color: #b21111;
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .contractLabel:hover {
        cursor: pointer;
        color: #b21111;
    }

    .contractLabel:hover .labelTip {
        display: block;
    }

    .labelTip {
        display: none;
        position: absolute;
        font-weight: 600;
        top: -65px;
        left: -50px;
        z-index: 1;
        width: 280px;
        text-align: left;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 1px 1px 5px #ccc;
        padding-left: 30px;
        z-index: 100;
        background-color: #000;
        opacity: 0.8;
        color: aliceblue;
    }
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components: {
            pagination,
            tabletem
        },
        data() {
            return {
                tableLoading: false,
                module: localStorage.dw_erp_power_code,
                trading_time: new Date(),
                addDialogVisible: false,
                initDialogVisible: false,
                dialogVisibleList: false,
                arrearList: [],
                add_params: {
                    order_id: "",
                    bill_type: 1,
                    amount: "",
                    account_id: "",
                    customer_id: "",
                    trading_time: "",
                    trading_mode_id: "",
                    course_title: "",
                    remark: "",
                    currency_id: "",
                    currency_rate: "",
                    files: []
                },
                ruleForm: {
                    ids: [],
                    salesman_id: ""
                },
                params: {
                    search: {
                        supplier_id: "",
                        salesman_id: "",
                        currency_id: [],
                    },
                    field: "",
                    sort: "",
                    per_page: 50,
                    page: 1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                list: [],
                selectMap: {
                    supplier: [],
                    user: [],
                    account: [],
                    paymentType: [],
                    purchaseCost: [],
                    currency: [],
                    settlementType: [],
                    purchaseBillType: []
                },
                tableCol: [
                    { colName: "供应商名称", colKey: "name", colWidth: 170, isSetWidth: true, isCanClick: false, isShow: true, },
                    { colName: "币种", colKey: "currency_name", colWidth: 120, isSetWidth: true, isCanClick: false, isShow: true, },
                    { colName: "其他应付", colKey: "other_amount", colWidth: 120, isSetWidth: true, isCanClick: true, isShow: true, isSort: true },
                    { colName: "采购余额", colKey: "balance", colWidth: 120, isSetWidth: true, isCanClick: false, isShow: true, isSort: true },
                    { colName: "未结金额", colKey: "unbalance", colWidth: 120, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "优惠/赔偿金", colKey: "paid_amount", colWidth: 120, isSetWidth: true, isCanClick: false, isShow: true, isSort: true },
                    { colName: "应付总额", colKey: "payment_amount", colWidth: 120, isSetWidth: true, isCanClick: false, isShow: true },
                    { colName: "明细详情", colKey: "see", colWidth: 90, isSetWidth: true, isCanClick: true, isShow: true, }
                    // {colName:"外币其他应付",colKey:"currency_name",colWidth:120,isSetWidth:true,isCanClick:true,isShow:true,isSort:true},
                    // {colName:"外币采购余额",colKey:"fc_balance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    // {colName:"外币未结金额",colKey:"fc_unbalance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    // {colName:"外币优惠/赔偿金",colKey:"fc_paid_amount",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    // {colName:"外币应付总额",colKey:"fc_payment_amount",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    // // {colName:"期初金额",colKey:"init_balance",colWidth:100,isSetWidth:true,isCanClick:true,isHideShowClickImg:true,isHideCanClickColor:true,isShow:true,isSort:true}, //add by xiong
                    // // {colName:"期初欠款",colKey:"init_debt",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                    // // {colName:"未付款",colKey:"debt",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isSort:true},
                ],
                selectRow: [],
                isInout: false,
                initForm: {
                    id: "",
                    amount: "",
                    remark: ""
                },
                totalObj: {
                    balance: 0,
                    unbalance: 0,
                    debt_amount: 0
                },
                sureDialogVisible: false,
                sure_params: {
                    amount: 0,
                    remark: '',
                    supplier_id: ''
                },
                salesmanList: [],
                seeId: "",
                addOtherDepositDialog: false,//其他应付弹框
                otherDeposit_params: {
                    id: '',
                    trading_time: "",
                    currency_id: "",
                    remark: "",
                    amount: "",
                    // account_id:"",
                    // supplier_id:"",
                    // payment_type_id:"",
                    // bill_type:1,
                    // currency_rate:"",
                    // files:[],
                    // is_invoice:'',
                },
                paymentAmount: '',
                purchaseShow: false,
                fileListShow: [],
                addSettlementDialog: false,//结算确认单
                settlement_params: {
                    trading_time: new Date(),
                    currency_id: "",
                    amount: '',
                    remark: '',
                    bill_type: "",
                    currency_rate: "",
                },
                otherDepositRules: {
                    trading_time: [{ required: true, message: '不能为空', trigger: 'change' }],
                    currency_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    amount: [{ required: true, message: '不能为空', trigger: 'change' }],
                    supplier_id: [{ required: true, message: '不能为空', trigger: 'change' }]
                },
                addRules: {
                    trading_time: [{ required: true, message: '不能为空', trigger: 'change' }],
                    account_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    supplier_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    bill_type: [{ required: true, message: '不能为空', trigger: 'change' }],
                    payment_type_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    currency_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    course_title: [{ required: true, message: '不能为空', trigger: 'change' }],
                    currency_rate: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                addSettlementDialogRules: {
                    currency_rate: [{ required: true, message: '不能为空', trigger: 'change' }],

                },
                paymentAmount: '',//付款金额
                purchaseBalance: '',//采购金额
                amountPayable: "",//应付金额
                currencyDis: false,
                otherDetailFlag: false,//其他应付
                otherDetail: [],
                otherTotal: {},
                isRenminbi: false,//判断是否有人民币
            }
        },
        created() {
            this.getSelectList("supplier")
            this.getSelectList("user")
            this.getSelectList("account")
            this.getSelectList("paymentType")
            this.getSelectList("purchaseCost")
            this.getSelectList("settlementType")
            this.getSelectList("purchaseBillType")
            this.getSelectList("currency")
            this.getList();
            this.getSalesman()
        },
        methods: {
            deleteF(id) {
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/customer.delete.debt", { id: id }, () => {
                        this.tip("删除成功", "success")
                        let obj = new Object();
                        obj.name = "debt";
                        obj.id = this.seeId;
                        this.rowClick(obj);
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //其他应付详情删除
            otherDetailDelete(index, id) {
                this.$confirm('确认是否删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc('/erp/supplier.init.bill.delete', { id: id }, () => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.otherDetail.splice(index, 1);
                        this.otherDetailFlag = false;
                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            getSalesman() {
                this.postFunc("/erp/customer.salesman.select", {}, res => {
                    this.salesmanList = res.data.data;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            addFirst() {
                this.initDialogVisible = !this.initDialogVisible;
                if (this.selectRow.length == 1) {
                    this.initForm.id = this.selectRow[0].id;
                    // this.initForm.amount = Number(this.selectRow[0].init_balance) >= 0 ? this.selectRow[0].init_balance:'';
                }
            },
            typeChange(val) {
                if (val == 0) {
                    this.add_params.course_title = "进销货款";
                } else {
                    this.add_params.course_title = "退货付款";
                }
            },
            getSelectList(target) {
                this.$getSelectList(target).then(res => {
                    this.selectMap[res.target] = res.list;
                })
            },
            //供应商退款/赔偿退款 剩余金额
            billChange() {
                let obj = {};
                this.selectMap.currency.forEach(item => {
                    if (item.id == this.add_params.currency_id) {
                        var currency_name = item.name;
                        if (currency_name == '人民币') {
                            this.add_params.currency_rate = 1;
                            this.isRenminbi = true;
                        } else {
                            this.add_params.currency_rate = '';
                            this.isRenminbi = false;
                        }
                    }
                })
                obj.supplier_id = this.selectRow[0].supplier_id;
                obj.type = this.add_params.bill_type;
                obj.currency_id = this.add_params.currency_id;
                this.postFunc("/erp/supplier.bill.amount", obj, res => {
                    this.add_params.amount = res.data.data;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            //结算获取金额
            currencyChange() {
                if (this.settlement_params.bill_type == 1) {
                    this.purchaseBalance = this.selectRow[0].balance;
                    this.amountPayable = this.selectRow[0].other_amount;
                } else {
                    this.selectMap.currency.forEach(item => {
                        if (item.id == this.settlement_params.currency_id) {
                            var currency_name = item.name;
                            if (currency_name == '人民币') {
                                this.settlement_params.currency_rate = 1;
                                this.isRenminbi = true;
                            } else {
                                this.settlement_params.currency_rate = '';
                                this.isRenminbi = false;
                            }
                        }
                    })
                    this.purchaseBalance = this.selectRow[0].paid_amount;
                    this.amountPayable = this.selectRow[0].other_amount;
                }
                // let obj ={};
                // obj.supplier_id = this.selectRow[0].supplier_id;
                // obj.type = this.settlement_params.bill_type;
                // obj.currency_id = this.settlement_params.currency_id;
                // this.postFunc("/erp/supplier.currency.amount",obj,res=>{
                //     this.purchaseBalance = res.data.data.amount;
                //     this.amountPayable = res.data.data.payment_amount;
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
            },
            saveInit() {
                // if(this.selectRow.length>0){
                //     if(this.selectRow[0].init_balance > 0){
                //         this.$confirm('修改期初余额，请谨慎操作。', '提示', {
                //             confirmButtonText: '确定',
                //             cancelButtonText: '取消',
                //             type: 'warning'
                //         }).then(() => {
                //             this.saveInitConfirm()
                //         }).catch(()=>{});
                //     }else{
                //         this.saveInitConfirm()
                //     }
                // }else{
                //     }
                this.saveInitConfirm()
            },
            saveInitConfirm() {
                this.postFuncLoading("/erp/supplier.add.init.debt", this.initForm, () => {
                    this.tip("添加成功", "success")
                    this.initDialogVisible = false;
                    this.getList()
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            addOrderSheet() {
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.order_id = 0;
                    this.add_params.trading_time = parseInt(this.trading_time.getTime() / 1000);
                    this.postFuncLoading("/erp/supplier.pay.amount", this.add_params, () => {
                        this.tip("操作成功", "success")
                        this.addDialogVisible = false;
                        this.dialogVisible = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            getList(flag) {
                if (flag) {
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.postFunc("/erp/supplier.payments", this.params, res => {
                    this.last_page = parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total = parseInt(res.data.data.list.total);
                    this.list = res.data.data.list.data;
                    this.list.forEach((item) => {
                        item.see = "明细详情";
                        item.other_amount = item.other_amount == '' ? '0.00' : item.other_amount;
                    })
                    this.totalObj = res.data.data.total;
                    // this.isInout=res.data.data.isInout;
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            excelExport() {
                this.$exportExecl("/erp/supplier.payments.export", "供应商付款", this.params)
            },
            batch() {
                if (this.selectRow.length < 1 || this.selectRow.length > 1) {
                    this.tip("请选择一条付款", "warning")
                } else {
                    this.add_params.supplier_id = this.selectRow[0].supplier_id;
                    this.add_params.currency_id = this.selectRow[0].currency_id == 0 ? '' : this.selectRow[0].currency_id;
                    if (this.selectRow[0].currency_name == '人民币') {
                        this.add_params.currency_rate = 1;
                        this.isRenminbi = true;
                    }
                    this.addDialogVisible = true;
                }
            },
            //其他应付
            payOtherDeposit() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                } else if (this.selectRow.length > 1) {
                    this.tip("请选择单条数据", "warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if (this.selectRow.length > 1) {
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].supplier_id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].currency_id;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.otherDeposit_params.contract_no = this.selectRow[0].contract_no;
                    this.addOtherDepositDialog = true;
                    this.otherDeposit_params.id = this.selectRow[0].supplier_id;;
                    this.otherDeposit_params.supplier_id = this.selectRow[0].supplier_id;
                    this.otherDeposit_params.currency_id = this.selectRow[0].currency_id;
                    this.purchaseShow = true
                }
            },
            //其他付款确认
            addotherDepositBack() {
                this.$confirm('是否确认添加?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.otherDeposit_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    // this.otherDeposit_params.currency_rate = Number(this.otherDeposit_params.currency_rate);
                    this.postFuncLoading("/erp/supplier.pay.other", this.otherDeposit_params, () => {
                        this.tip("操作成功", "success")
                        this.addOtherDepositDialog = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            //结算
            settlementOpen() {
                let num = 0;
                let ids = [];
                if (this.selectRow.length < 1) {
                    this.tip("请选择数据", "warning");
                    return
                } else if (this.selectRow.length > 1) {
                    this.tip("请选择单条数据", "warning");
                    return
                }
                // for(let i=0; i<this.selectRow.length;i++){
                //     if(this.selectRow[0].supplier_id !=this.selectRow[i].supplier_id){
                //         this.tip("付款，供应商必须相同！","warning");
                //         return
                //     }else{
                //         ids.push(this.selectRow[i].id);
                //     }
                //     num = i;
                // }
                if (this.selectRow.length > 1) {
                    this.addSettlementDialog = true;
                    this.settlement_params.id = this.selectRow[0].supplier_id;
                    this.settlement_params.supplier_id = this.selectRow[0].supplier_id;
                    this.settlement_params.currency_id = this.selectRow[0].currency_id;
                    this.amountPayable = this.selectRow[0].other_amount;
                    this.settlement_params.amount = this.amountPayable;
                    this.purchaseShow = false
                } else if (this.selectRow.length == 1) {
                    this.addSettlementDialog = true;
                    this.settlement_params.id = this.selectRow[0].supplier_id;
                    this.settlement_params.supplier_id = this.selectRow[0].supplier_id;
                    this.settlement_params.currency_id = this.selectRow[0].currency_id;
                    this.amountPayable = this.selectRow[0].other_amount;
                    this.settlement_params.amount = this.amountPayable
                    this.purchaseShow = true
                }
                // this.purchaseBalance = this.selectRow[0].balance;
                // this.paidAmount = this.selectRow[0].fc_paid_amount;
                // this.amountPayable = this.selectRow[0].payment_amount;
            },
            //结算确认
            addsettlementBack() {
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.settlement_params.trading_time = parseInt(this.trading_time.getTime() / 1000)
                    this.postFuncLoading("/erp/supplier.settlement.other", this.settlement_params, () => {
                        this.tip("结算成功", "success")
                        this.addSettlementDialog = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            changeRate(e, input) {
                e.target.value = (e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})", "g"))[0]) || null
                this.input = e.target.value
                this.add_params.amount = this.input
            },
            // 付款金额计算
            AmountCalculation(e, value) {
                if (value == '') {
                    value = 1
                }
                this.paymentAmount = this.keepPrices(this.$bc_mul(e, value))
            },
            //modified by xiong
            rowClick(obj, row) {
                if (obj.name == "init_balance") {
                    this.list.forEach(item => {
                        if (item.id == obj.id) {
                            item.init_remark = item.init_remark == "" ? "未填写备注内容" : item.init_remark
                            this.$alert(item.init_remark, '备注', {
                                confirmButtonText: '关闭',
                                callback: action => {
                                    window.console.log(action)
                                }
                            })
                        }
                    })
                } if (obj.name == "debt") {
                    this.seeId = obj.id;
                    this.postFuncLoading("/erp/customer.get.debts", { customer_id: obj.id }, res => {
                        res.data.data.forEach(item => {
                            if (item.add_time != 0) {
                                item.add_time = this.formatTime(item.add_time * 1000)
                            } else {
                                item.add_time = "";
                            }
                        })
                        this.arrearList = res.data.data;
                        this.dialogVisibleList = true;
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                } else if (obj.name == "fc_other_amount") {
                    this.list.forEach(item => {
                        if (item.id == obj.id) {
                            //外币其他应付
                            this.postFuncLoading('/erp/supplier.init.bills', { id: obj.id }, res => {
                                res.data.data.list.forEach(item => {
                                    if (item.trading_time != 0) {
                                        item.trading_time = this.formatTime(item.trading_time * 1000)
                                    } else {
                                        item.trading_time = "";
                                    }
                                })
                                this.otherDetail = res.data.data.list;
                                this.otherTotal = res.data.data.total;
                                this.otherDetailFlag = true;
                            }, error => {
                                this.tip(error.data.message, "warning")
                            })
                        }
                    })
                } else if (obj.name == "other_amount") {
                    this.list.forEach(item => {
                        if (item.id == obj.id) {
                            //外币其他应付
                            this.postFuncLoading('/erp/supplier.other.rmb.bills', { id: obj.row.supplier_id, currency_id: obj.row.currency_id }, res => {
                                res.data.data.list.forEach(item => {
                                    if (item.trading_time != 0) {
                                        item.trading_time = this.formatTime(item.trading_time * 1000)
                                    } else {
                                        item.trading_time = "";
                                    }
                                })
                                this.otherDetail = res.data.data.list;
                                this.otherTotal = res.data.data.total;
                                this.otherDetailFlag = true;
                            }, error => {
                                this.tip(error.data.message, "warning")
                            })
                        }
                    })
                } else {
                    sessionStorage.removeItem("DEMU_ERP_RECEIVABLEDETAIL_ID")
                    sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_TYPE")
                    sessionStorage.setItem("DEMU_ERP_RECEIVABLEDETAIL_ID", obj.row.supplier_id)
                    sessionStorage.setItem("DEMU_ERP_PAYSUMMARY_TYPE", 2)
                    this.$root.$children[0].$children[0].addTab({
                        name: '明细详情' + obj.id,
                        label: '明细详情',
                        content: 'payReceivableDetail'
                    });
                }
            },
            getRow(row) {
                this.selectRow = row;
            },
            resetSearch() {
                this.params = { search: { customer_id: "", salesman_id: "" }, per_page: 50, page: 1, field: "", sort: "" }
                this.getList()
            },
            getPage(obj) {
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            //表格排序
            sortTable(sort) {
                this.params.field = sort.order ? sort.prop : '';
                this.params.sort = sort.order == "ascending" ? "asc" : sort.order == "descending" ? "desc" : "";
                this.getList();
            },
            //结算 created by xiong
            addSettle() {
                if (this.selectRow.length == 0) {
                    this.tip('请选择需要结算客户', 'warning')
                    return
                }
                if (this.selectRow.length > 1) {
                    this.tip('不能同时对多个客户进行结算作', 'warning')
                    return
                }
                this.sureDialogVisible = true;
                this.sure_params.amount = this.selectRow[0].debt;
                // let init_balance = this.selectRow[0].init_balance + ''
                // if(init_balance.indexOf('-') == -1){
                //     this.sure_params.amount = init_balance
                // }else{
                //     this.sure_params.amount = init_balance.substr(1)
                // }
            },
            settlement() {
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sure_params.customer_id = this.selectRow[0].id
                    this.sure_params.amount = parseFloat(this.sure_params.amount)
                    this.postFuncLoading("erp/finance.settlement.debt", this.sure_params, () => {
                        this.tip("结算成功", "success")
                        this.sureDialogVisible = false;
                        this.getList()
                    }, error => {
                        this.tip(error.data.message, "warning")
                    })
                }).catch(() => { });
            },
            settlementInput(val) {
                var reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
                if (reg.test(val)) {
                    this.sure_params.amount = val;
                } else {
                    this.sure_params.amount = '';
                }
            },
            settleClose() {
                this.sure_params.amount = ''
                this.sure_params.remark = ''
            }
            //结算 end
        },
        watch: {
            "params.page": function () {
                this.getList();
            },
            "params.per_page": function () {
                this.getList();
            },
            "addDialogVisible": function (val) {
                if (!val) {
                    this.add_params = {
                        order_id: "",
                        bill_type: 1,
                        amount: "",
                        account_id: "",
                        customer_id: "",
                        trading_time: "",
                        trading_mode_id: "",
                        course_title: "",
                        remark: "",
                        currency_id: "",
                        currency_rate: "",
                        files: []
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                    this.isRenminbi = false;
                }
            },
            "initDialogVisible": function (val) {
                if (!val) {
                    this.initForm = this.resetJson(this.initForm)
                }
            },
            "addOtherDepositDialog": function (val) {//其他
                if (!val) {
                    this.otherDeposit_params = {
                        id: '',
                        trading_time: "",
                        currency_id: "",
                        remark: "",
                        amount: "",
                    }
                    this.fileListShow = [];
                    this.paymentAmount = '';
                }
            },
            "addSettlementDialog": function (val) {//结算
                if (!val) {
                    this.settlement_params = this.resetJson(this.settlement_params);
                    this.purchaseBalance = '';
                    this.amountPayable = '';
                    this.isRenminbi = false;
                    this.paymentAmount = '';
                }
            },
        }
    }
</script>